<template>
    <div class="demand">
        <div class="searchPart">
            <el-input v-model="orderNo" placeholder="订单编号"></el-input>
            <el-input v-model="creator" placeholder="买家昵称"></el-input>

            <el-select v-model="status" placeholder="处理状态">
                <el-option label="待处理" value="AUDIT"></el-option>
                <el-option label="已处理" value="PASS"></el-option>
                <el-option label="已取消" value="CANCEL"></el-option>
            </el-select>
            <el-button class="searchBtn" @click="search">搜索</el-button>
            <el-button type="text" class="resetBtn" @click="reset">
                <i class="iconfont icon-qingchushujuku"></i>
                <span>清除条件</span>
            </el-button>
        </div>
        <div class="tablePart">
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
            >
                <!-- <el-table-column
                  prop="compNum"
                  label="投诉编号"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
                  width="180"
                >
                </el-table-column> -->
                <el-table-column
                    prop="orderNo"
                    label="订单编号"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    prop="creator"
                    label="买家昵称"
                    header-align="center"
                    align="center"
                >
                    <template slot-scope="scope">
                        <div class="complaintsimg">
                            <p>{{ scope.row.creator }}</p>
                            <i class="iconfont icon-weixin" style="font-size: 25px; cursor: pointer" @click="startChat(scope.row.creatorUuid)"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="投诉时间"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="complainContent"
                    label="投诉内容"
                    header-align="center"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    prop="statusCn"
                    label="状态"
                    header-align="center"
                    align="center"
                    width="110"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    header-align="center"
                    align="center"
                    width="230"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="toDialog(scope.row)">投诉详情</el-button>
                        <!-- <el-button
                          type="text"
                          size="small"
                          v-if="scope.row.complaintState == '处理中'"
                          @click="toDialog(1)"
                          >我要申诉</el-button
                        > -->
                    </template>
                </el-table-column>
                 <template slot="empty">
                    <img src="../../assets/images/暂无内容.jpg" alt="" style="width:200px">
                 </template>
            </el-table>
            <el-pagination
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
                class="pagination"
            >
            </el-pagination>
            <el-dialog title="投诉详情" :visible.sync="dialogComplaints">
                <div class="checkMessage">
                    <div class="checkMessageBox">
                        <p class="checkMessageTitle">投诉信息</p>
                        <div class="checkMessageContent">
                            <div class="checkBox">
                                <span>买家昵称：</span>
                                <p>{{complaintMess.name}}</p>
                            </div>
                            <div class="checkBox">
                                <span>订单编号：</span>
                                <p>{{complaintMess.orderNumber}}</p>
                            </div>
                             <div class="checkBox">
                                <span>联系电话：</span>
                                <p>{{complaintMess.telephont}}</p>
                            </div>
                            <div class="checkBox">
                                <span>投诉时间：</span>
                                <p>{{complaintMess.times}}</p>
                            </div>
                            <div class="checkBox" style="width:100%">
                                <span>投诉原因：</span>
                                <p>{{complaintMess.reason}}</p>
                            </div>
                            <div class="checkBox" style="width:100%">
                                <span>投诉凭证：</span>
                                <el-image
                                    v-for="(img,index) in complaintMess.imgs"
                                    :key="index"
                                    style="width: 100px; height: 100px"
                                    :src="img"
                                    :preview-src-list="complaintMess.imgs">
                                </el-image>
                                <!--                <img :src="complaintMess.imgs" alt="" />-->
                            </div>

                        </div>
                    </div>
                    <div class="checkMessageBox">
                        <p class="checkMessageTitle">处理信息</p>
                        <div v-if="complaintMess.status !== 'AUDIT'">
                            {{ complaintMess.auditReason }}
                        </div>
                        <div class="checkMessageContent2">{{complaintMess.status}}</div>
                    </div>
                </div>
            </el-dialog>
        </div>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import uploadFile from "@/components/uploadFile";
import {getOrderComplainList, getRongCloudUser} from "../../utils/interface";
import chatDialog from "../../components/chat/chatDialog";
export default {
    data() {
        return {
            orderNo: "",
            status: "",
            creator: "",
            dialogComplaints: false,
            formComplaints: {
                content: "",
                fileList: [],
            },
            tableData: [],
            current: 0,
            pageSize: 10,
            total: 0,
            demandSelection: [],
            headers: {
                Authorization: "Bearer " + this.$cookies.get("api_access_token"),
            },
            // 投诉详情
            complaintMess: {
                name: '芜湖铸造有限公司',
                ordernumber: '79732985472399',
                reason:'投诉原因',
                imgs:'',
                telephont:'16768298999',
                times:'021-10-09',
                status:'待处理',
                auditReason:''
            }
        };
    },
    components: {
        uploadFile,
        chatDialog
    },
    computed: {
        ...mapState({}),
    },
    created() {
        this.search();
    },
    methods: {
        // 清除检索条件
        reset() {
            this.orderNo = "";
            this.status = "";
            this.creator = "";
            this.search();
        },
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.search();
        },
        search() {
            let params = {
                orderNo: this.orderNo,
                status: this.status,
                creator: this.creator,
                current: this.current,
                pageSize: this.pageSize,
                type: 'APPEAL'
            };
            getOrderComplainList(params).then((res) => {
                this.current = res.current;
                this.total = res.total;
                this.tableData = res.list;
            });
        },
        publishSubmit() {},
        // 我要申诉
        toDialog(item) {
            this.complaintMess.reason = item.complainContent;
            this.complaintMess.orderNumber = item.orderNo;
            this.complaintMess.name = item.creator;
            this.complaintMess.telephont = item.creatorPhone;
            this.complaintMess.times = item.createTime;
            if(item.complainImg && item.complainImg.length > 0) {
                this.complaintMess.imgs = item.complainImg.split(",");
            }
            this.complaintMess.status = item.statusCn;
            this.complaintMess.auditReason = item.auditReason;
            this.dialogComplaints = true;
        },
        // 删除模型文件
        handleRemove(file) {
            this.formComplaints.fileList = file;
        },
        // 上传文件
        handleAvatarSuccess(res, file) {
            this.formComplaints.fileList = file;

        },
        startChat(targetUuid) {
            let user = this.$store.state.userMessages;
            getRongCloudUser (targetUuid).then(res=> {
                console.log(res);
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
            });
        },
    },
};
</script>

<style scoped lang="less">
.demand {
    padding: 20px;
    .releaseBox {
        background: #fff;
        padding: 35px;
        padding-top: 0;
        box-sizing: border-box;
        .releaseBoxTop {
            margin-bottom: 15px;
            h4 {
                font-size: 18px;
                color: #157efa;
                margin-bottom: 18px;
            }
            .releaseBoxTopInput {
                font-size: 14px;
                color: #262626;
                align-items: center;
                margin-bottom: 20px;
                /deep/.ql-toolbar.ql-snow {
                    display: none;
                }
                /deep/.ql-toolbar.ql-snow + .ql-container.ql-snow {
                    border-top: 1px solid #ccc;
                }
                .releaseBoxTopInputBox {
                    flex-wrap: wrap;
                }
                input {
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    border: none;
                    padding-left: 8px;
                    box-sizing: border-box;
                }
                .input2 {
                    width: 161px;
                    // margin-left: 90px;
                }
                textarea {
                    width: 614px;
                    height: 206px;
                    background: #f5f5f5;
                    opacity: 1;
                    border-radius: 6px;
                    border: none;
                    padding: 8px;
                    box-sizing: border-box;
                }
                /deep/.el-input--prefix .el-input__inner {
                    width: 161px;
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    border: none;
                    //   padding-left: 8px;
                    box-sizing: border-box;
                    //   margin-left: 25px;
                }
                // /deep/.el-input__prefix {
                //   right: -132px;
                //   left: 0;
                // }
                /deep/.el-input__icon {
                    line-height: 30px;
                }
                .releaseBoxbotInputP {
                    width: 94px;
                    flex-shrink: 0;
                    white-space: nowrap;
                }
                .releaseBut {
                    background: #157efb;
                    color: #fff;
                }
                button {
                    width: 100px;
                    height: 30px;
                    background: #f5f5f5;
                    border-radius: 4px;
                    border: none;
                    margin-right: 20px;
                    color: #262626;
                    font-size: 14px;
                    cursor: pointer;
                }
            }
        }
    }

    .searchPart {
        display: flex;
        flex-wrap: wrap;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover,
            &:focus {
                background-color: #fff;
                border: 1px solid #108ee9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom: 22px;
        }
    }

    .tablePart {
        .tableTool {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            .toolLeft {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.847);

                .num {
                    color: #356fdf;
                }

                button {
                    padding: 0;
                    margin-left: 15px;
                    width: 80px;
                    height: 30px;
                    background: rgba(242, 244, 247, 1);
                    box-sizing: border-box;
                    border: 1px solid rgba(21, 126, 251, 1);
                    border-radius: 5px;
                    font-size: 12px;
                    color: #157efb;
                    line-height: 30px;
                    text-align: center;

                    &:hover {
                        background: #157efb;
                        box-sizing: border-box;
                        border: 1px solid #157efb;
                        color: #fff;
                    }
                }
            }

            .toolRight {
                button {
                    width: 83px;
                    height: 30px;
                    background: rgba(21, 126, 251, 1);
                    border: none;
                    border-radius: 15px;
                    font-size: 13px;
                    color: #fff;

                    i {
                        padding-right: 5px;
                    }

                    &:hover {
                        background: #61a2f0;
                    }
                }
            }
        }

        .tableContent {
            min-height: 650px;
            .complaintsimg {
                display: flex;
                align-items: center;
                justify-content: center;
                i {
                    color: #108ee9;
                    margin-left: 10px;
                }
            }
            /deep/ .el-table__header {
                tr {
                    th {
                        border-right: none;
                    }
                }

                /deep/ .el-table__cell {
                    padding: 5px 0;
                    background: #f2f5fc;
                }
            }

            /deep/ .el-table__body {
                img {
                    vertical-align: middle;
                    width: 52px;
                    height: 50px;
                }

                /deep/ .el-table__row {
                    td:first-child {
                        border-right: none;

                        .cell {
                            padding-left: 15px;
                        }
                    }
                }
            }
        }

        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
}
/deep/.el-dialog__body {
    padding-top: 0;
}
.itemFlex {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    .name {
        margin-left: 10px;
        /deep/p {
            margin: 0 !important;
        }
    }
}
.checkMessage {
    padding-top: 20px;
    border-top: 1px solid #efefef;
    .checkMessageBox {
        .checkMessageTitle {
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 20px;
        }
        .checkMessageContent {
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            .checkBox {
                width: 50%;
                display: flex;
                align-items: center;
                .el-image{
                    margin-right: 20px;
                }
                img {
                    width: 30px;

                }
            }
        }
        .checkMessageContent2 {
            width: 106px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            background: #34c759;
            border-radius: 2px;
            font-size: 14px;
            font-weight: 500;
            color: #fff;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/transaction/complaintsMine.vue